import { SearchCategoryFilter, SearchResultCategory } from "./GlobalSearch.Types";

// "Address"/"FMS ID" preview Phase 2 — no real matches under Locations yet.
export const SEARCH_EXAMPLES: Record<SearchCategoryFilter, string[]> = {
  all: ["Lock", "Hours", "FMS ID"],
  [SearchResultCategory.LOCATION]: ["Name", "Address", "FMS ID"],
  [SearchResultCategory.DETAILS_V3]: ["Lock", "Hours", "URL"],
  [SearchResultCategory.POLICY]: ["Gate Code", "Late Fee", "Auction"],
  [SearchResultCategory.REPORT]: ["Payments", "Conversions", "Google Reviews"]
};
